var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 61,
    viewBox: "0 0 85 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3402 58.1491C39.7048 60.5983 40.9004 61.4426 42.9989 60.0216L58.976 49.1967C61.0745 47.7757 64.5024 45.4519 66.6009 44.0309L82.578 33.206C84.6765 31.785 84.6765 29.4612 82.578 28.0402L66.6009 17.2153C64.5024 15.7943 61.0745 13.4705 58.976 12.0495L42.9989 1.22466C40.9004 -0.196364 39.7048 0.647892 40.3402 3.09707L44.1694 17.9008C44.8048 20.3499 43.2497 22.3561 40.7165 22.3561H4.69899C2.16573 22.3561 0.0923462 24.4291 0.0923462 26.9619V34.2843C0.0923462 36.8171 2.16573 38.8901 4.69899 38.8901H40.7165C43.2497 38.8901 44.8048 40.8963 44.1694 43.3454L40.3402 58.1491Z",
    fill: "#A2CFE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3275f30c26ab4bf3657e3631c17ccb96.svg";
export { ForwardRef as ReactComponent };